var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2994 5.91976H15.3065V4.84658C15.3065 3.82835 14.4781 3 13.4599 3H10.5401C9.52194 3 8.69355 3.82835 8.69355 4.84658V5.91973H4.70061C4.48703 5.91973 4.31389 6.09287 4.31389 6.30645V9.22621C4.31389 9.43978 4.48703 9.61293 4.70061 9.61293H5.77375V19.1534C5.77375 20.1716 6.60214 21 7.62037 21H16.3796C17.3978 21 18.2262 20.1716 18.2262 19.1534V9.61296H19.2993C19.5129 9.61296 19.6861 9.43982 19.6861 9.22624V6.30648C19.6861 6.09291 19.513 5.91976 19.2994 5.91976ZM9.46695 4.84658C9.46695 4.25483 9.94838 3.77344 10.5401 3.77344H13.4599C14.0516 3.77344 14.533 4.25483 14.533 4.84658V5.91973H9.46695V4.84658ZM17.4528 19.1534C17.4528 19.7452 16.9714 20.2266 16.3797 20.2266H7.62037C7.02862 20.2266 6.54719 19.7452 6.54719 19.1534V9.61296H17.4528V19.1534ZM18.9127 8.83952H5.08733V6.6932H18.9127V8.83952Z",
    fill: "#464646"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08023 18.0802C8.86666 18.0802 8.69351 17.9071 8.69351 17.6935V12.146C8.69351 11.9324 8.86666 11.7592 9.08023 11.7592C9.2938 11.7592 9.46695 11.9324 9.46695 12.146V17.6935C9.46695 17.9071 9.29384 18.0802 9.08023 18.0802Z",
    fill: "#464646"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.0802C11.7864 18.0802 11.6133 17.9071 11.6133 17.6935V12.146C11.6133 11.9324 11.7864 11.7592 12 11.7592C12.2136 11.7592 12.3867 11.9324 12.3867 12.146V17.6935C12.3867 17.9071 12.2136 18.0802 12 18.0802Z",
    fill: "#464646"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9198 18.0802C14.7062 18.0802 14.533 17.9071 14.533 17.6935V12.146C14.533 11.9324 14.7062 11.7592 14.9198 11.7592C15.1333 11.7592 15.3065 11.9324 15.3065 12.146V17.6935C15.3065 17.9071 15.1333 18.0802 14.9198 18.0802Z",
    fill: "#464646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.b0f3f46eee748a2f5b7e78d9625cc853.svg";
export { ForwardRef as ReactComponent };